import { Modal } from "@flash-tecnologia/flamingo-ui-modal";
import dispatchToast from "@utils/dispatch-toast";

interface DeleteMemberModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const DeleteMemberModal = ({
  open,
  onClose,
  onSubmit,
}: DeleteMemberModalProps) => {
  const handleDeleteMemberSubmit = async () => {
    try {
      dispatchToast({
        content: "Membro excluído com sucesso!",
        type: "success",
      });
      onSubmit();
    } catch (error) {
      dispatchToast({
        content:
          "Ocorreu um erro ao excluir esta pessoa. Tente novamente mais tarde.",
        type: "error",
      });
    }
  };

  return (
    <Modal.Root open={open} onOpenChange={() => open && onClose()} size="small">
      <Modal.Content.Root>
        <Modal.Content.Highlight
          customIconName="IconAlertCircle"
          size="compact"
          type="warning"
        >
          Atenção!
        </Modal.Content.Highlight>
        <Modal.Content.Title>
          Tem certeza que deseja excluir esta pessoa?{" "}
        </Modal.Content.Title>
        <Modal.Content.Description>
          Essa ação é permanente e não poderá ser desfeita.
        </Modal.Content.Description>
        <Modal.Content.Footer>
          <Modal.Content.Footer.CancelButton onClick={onClose}>
            Cancelar
          </Modal.Content.Footer.CancelButton>
          <Modal.Content.Footer.PrimaryButton
            variantType="attention"
            onClick={handleDeleteMemberSubmit}
          >
            Excluir pessoa
          </Modal.Content.Footer.PrimaryButton>
        </Modal.Content.Footer>
      </Modal.Content.Root>
    </Modal.Root>
  );
};
